import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class CommonSurveyAnalytics extends BaseAnalytics {
    constructor(category = 'feedback') {
        super();

        this.category = category;
    }

    clickSurveyButton() {
        this.send('click_feedback');
    }

    clickTakeSurvey() {
        this.send('open_survey');
    }

    closePopup() {
        this.send('close_popup');
    }
}

export default CommonSurveyAnalytics;
